<app-card
  title="Payment Information"
  headerClasses="p-4 is-size-3 has-text-weight-bold is-size-4-mobile card-header-title"
  contentClasses="p-4 card-body-background"
  data-qa-id="Upsell Payment Information Card"
>
  <app-embedded-order-summary [totalInCents]="totalDue" [itemRows]="orderSummaryRows"></app-embedded-order-summary>
  <app-payment-step-tabs
    #paymentStepTabs
    [enablePayLater]="enablePayLater"
    [hasPartner]="false"
    [totalAmount]="total / 100"
    (paymentsSelected)="onPaymentsSelected($event)"
    (formValid)="formValid.emit()"
  >
  </app-payment-step-tabs>
</app-card>
